// latest: zhangmyh 2017-9-6 3:43 PM
/* global ko */

import './index.less'

export default function (params) {
  this.title = params.title || '请输入驳回原因:'
  this.maxlength = params.maxlength || 200
  this.reason = ko.observable('')
  this.visible = params.visible
  let handleOK = params.onOK || function () {
    return true
  }
  let handleCancel = params.onCancel || function () {}
  this.onOK = async function () {
    let result = await handleOK(this.reason())
    if (result) {
      this.visible(false)
    }
  }
  this.onCancel = function () {
    handleCancel(this.reason())
    this.visible(false)
  }
}



// WEBPACK FOOTER //
// ./src/components/confirm-with-reason-select/index.js